import { render } from "./CreateDocumentModal.vue?vue&type=template&id=3654178e"
import script from "./CreateDocumentModal.vue?vue&type=script&lang=js"
export * from "./CreateDocumentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__